module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "frontmatter",
      "title": "List of Abbreviations"
    }
  }, [_c('p', {
    staticClass: "FMO"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xi",
      "title": "xi"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/00a_fm0e#list"
    }
  }, [_vm._v("LIST OF ABBREVIATIONS")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("For the purpose of space, the following abbreviations are used for frequently cited sources from the period.")]), _vm._v(" "), _c('p', {
    staticClass: "center1"
  }, [_c('b', [_vm._v("Newspapers")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("BJ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Brightmoor Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("CPD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Cleveland Plain Dealer")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("DFP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Detroit Free Press")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("DJ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Detroit Journal")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("DJC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Detroit Jewish Chronicle")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("DN")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Detroit News")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("DNT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Detroit News-Tribune")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("DSFP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Detroit Sunday Free Press")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("DSN")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Detroit Sunday News")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("DST")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Detroit Sunday Times")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("DT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Detroit Times")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("FN")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Ferndale News")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("HN")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Hamtramck News")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("HP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Highland Parker")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('b', [_vm._v("Industry Magazines")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("EFM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Educational Film Magazine")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("EH")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Exhibitors Herald")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("ETR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Exhibitors Trade Review")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("FD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Film Daily / Wid’s Daily")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("FT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Ford Times")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("M")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Motography")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("MFR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Michigan Film Review")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("MPA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Moving Picture Age")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("MPM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Motion Picture Magazine")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_xii",
      "title": "xii"
    }
  }, [_vm._v("MPN")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Motion Picture News")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("MPW")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Moving Picture World")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("PM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Photoplay Magazine")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("R&S")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Reel and Slide")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("V")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Variety")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('p', {
    staticClass: "center1"
  }, [_c('b', [_vm._v("Miscellaneous")])]), _vm._v(" "), _c('div', {
    staticClass: "top"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("E&P")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Editor & Publisher")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("PW")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Photoplay Weekly")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_vm._v("WFN")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "Table-Text"
  }, [_c('i', [_vm._v("Weekly Film News")])])])])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5bc443d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/00a_fm0g.vue
// module id = 78
// module chunks = 0